export const baseUrl = process.env.VUE_APP_BASEURL
// export const uploadUrl = process.env.VUE_APP_UPLOAD
export const uploadUrl = "";